/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Images_TitleInputs */

const vi_shop_group_images_title = /** @type {(inputs: Shop_Group_Images_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh lấy từ sản phẩm ERP`)
};

/**

* @param {Shop_Group_Images_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_images_title = /** @type {((inputs?: Shop_Group_Images_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Images_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_images_title(inputs)
});